import { z } from "zod";

export const InterestCalculationMethodEnum = {
  SIMPLE: 'simple',
  COMPOUND: 'compound',
  PMT: 'pmt',
} as const;

export const interestCalculationMethodSchema = z.enum([
  InterestCalculationMethodEnum.SIMPLE,
  InterestCalculationMethodEnum.COMPOUND,
  InterestCalculationMethodEnum.PMT,
]);

export type InterestCalculationMethod = z.infer<typeof interestCalculationMethodSchema>;